/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hasprice1Inputs */

const en__field_hasprice1 = /** @type {(inputs: _Field_Hasprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charged`)
};

const de__field_hasprice1 = /** @type {(inputs: _Field_Hasprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenpflichtig`)
};

/**
* | output |
* | --- |
* | "Charged" |
*
* @param {_Field_Hasprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hasprice1 = /** @type {((inputs?: _Field_Hasprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hasprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hasprice1(inputs)
	return de__field_hasprice1(inputs)
});
export { _field_hasprice1 as "_field_hasPrice" }